import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { AppFooterModel } from '@libs/cms/models';
import { IconComponent } from '@libs/components/icons';
import { NavModel } from '@libs/shared/models';
import { ContentLinkDirective, NavLinkDirective } from '@libs/shared/ui';
import { NgTemplateOutlet } from '@angular/common';
import { DateTime } from 'luxon';

@Component({
  selector: 'ui-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    NavLinkDirective,
    IconComponent,
    MatButton,
    ContentLinkDirective,
  ],
})
export class FooterComponent {
  public data: InputSignal<AppFooterModel> = input.required();
  public legalNav: InputSignal<NavModel | undefined> = input<NavModel>();
  public copyright: InputSignal<string> = input.required();

  public copyrightText: Signal<string> = computed(() => {
    const year: number = DateTime.now().year;

    return `${this.copyright()} ${year}`;
  });
}
